import apiClient from './api'

export interface VoiceCommandResponse {
    success: boolean
    message: string
    action: string
    data?: any
}

export interface VoiceCommandHistoryItem {
    id: string
    timestamp: string
    command: string
    action: string
    success: boolean
    message: string
}

export interface TranscriptionResponse {
    success: boolean
    text?: string
    duration?: number
    error?: string
}

export interface WhisperStatus {
    available: boolean
    service: 'whisper' | 'web-speech-api'
}

/**
 * Send a voice command to the backend
 */
export async function sendVoiceCommand(text: string): Promise<VoiceCommandResponse> {
    const response = await apiClient.post<VoiceCommandResponse>('/api/president/command', { text })
    return response
}

/**
 * Transcribe audio using Whisper API
 */
export async function transcribeAudio(audioBlob: Blob): Promise<TranscriptionResponse> {
    const formData = new FormData()
    formData.append('audio', audioBlob, 'recording.webm')

    const response = await fetch(`${import.meta.env.VITE_API_URL}/api/president/transcribe`, {
        method: 'POST',
        body: formData,
        credentials: 'include',
    })

    const data = await response.json()
    return data
}

/**
 * Check if Whisper API is available
 */
export async function checkWhisperAvailability(): Promise<WhisperStatus> {
    try {
        const response = await apiClient.get<WhisperStatus>('/api/president/transcribe/status')
        return response
    } catch {
        return { available: false, service: 'web-speech-api' }
    }
}

/**
 * Get voice command history
 */
export async function getCommandHistory(limit = 20): Promise<VoiceCommandHistoryItem[]> {
    const response = await apiClient.get<{ success: boolean; data: VoiceCommandHistoryItem[] }>(
        `/api/president/command/history?limit=${limit}`
    )
    return response.data
}

